
import React from "react";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { Control } from "react-hook-form";

type DescriptionFieldProps = {
  control: Control<any>;
};

const DescriptionField: React.FC<DescriptionFieldProps> = ({ control }) => {
  return (
    <FormField
      control={control}
      name="description"
      render={({ field }) => (
        <FormItem>
          <FormLabel className="text-sm text-muted-foreground mb-1">Açıklama</FormLabel>
          <FormControl>
            <Textarea 
              placeholder="Masraf açıklaması girin"
              {...field}
              className="min-h-[80px] bg-background"
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default DescriptionField;
